// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 8764) return "js/8764-acc8d748d3b424c3dc96.js";
	// return url for filenames based on template
	return "js/" + chunkId + "-" + "f9ceb6c2da17604dabca" + ".chunk.js";
};